export interface IContactItem {
  account_firstname: string;
  account_id: number;
  account_lastname: string;
  action_response: string;
  contact_active: string;
  contact_bounced: string;
  contact_company: string;
  contact_created: string;
  contact_email: string;
  contact_firstname: string;
  contact_id: number;
  contact_lastname: string;
  contact_title: string;
  contact_valid: number;
  contact_vip: boolean;
  email_position: string;
  group_id: number;
  group_name: string;
  group_status: string;
  last_email: string;
  next_email: string;
  next_frequency: string;
  contact_status: string;
  action_name: string;
  active_for_campaigns: boolean;
}

export interface IContact {
  account_id: number;
  active_for_campaigns: boolean;
  address1: string;
  address2: string;
  age: number;
  category: string;
  city: string;
  company: string;
  company_address: string;
  company_city: string;
  company_country: string;
  company_state: string;
  company_url: string;
  company_zip: string;
  contact_id: number;
  date_aquired: string;
  department1: string;
  department2: string;
  department3: string;
  email: string;
  employees: number;
  fax: string;
  firstname: string;
  group_id: number;
  id: number;
  industry1: string;
  industry2: string;
  industry3: string;
  lastname: string;
  level: string;
  mobile_phone: string;
  phone_number: string;
  private_note: string;
  revenue: number;
  revision: number;
  state: string;
  status: number;
  stock_exchange: string;
  subindustry1: string;
  subindustry2: string;
  subindustry3: string;
  tags: string;
  ticker_symbol: string;
  title: string;
  zip_code: string;
  contact_age: number;
  created_at: string;
  next_email?: string;
  campaign_id?: number;
  campaign_name?: string;
  email_position: number;
  message_id?: number;
  variable1?: string;
  variable2?: string;
  variable3?: string;
  alternate_email_1?: string;
  alternate_email_2?: string;
  alternate_email_3?: string;
  reply_action: string;
  reply_action_id: number;
  reply_action_response: string;
  contact_next_email: string;
  contact_email_position: number;
  contact_status: string;
  last_email_at: string;
  next_email_at: string;
  group_name?: string;
}

export interface IContactGroup {
  account_firstname: string;
  account_id: number;
  account_lastname: string;
  campaign_active: string;
  campaign_deleted: string;
  campaign_id: number;
  campaign_name: string;
  campaign_type: string;
  content_name: string;
  group_created: string;
  group_id: number;
  group_name: string;
  group_status: string;
}

export interface IContactActivity {
  activity_content: string;
  activity_message: string;
  contact_id: number;
  activity_id: number;
  message_date: string;
  message_type: string;
  message_details: string;
  activity_date: string;
  activity_type: string;
}

export interface IContactActivityAttachment {
  id: number;
  content_type: string;
  file_name: string;
}

export interface IContactActivityNote {
  attachments: IContactActivityAttachment;
  conversation_id: number;
  created_at: string;
  deleted_at: string;
  id: number;
  note: string;
  of_type: string;
  title: string;
  updated_at: string;
  user_contact_id: number;
}

export interface IContactFieldsMapping {
  map: {
    [key: string]: string;
  };
  samples: [{
    [key: string]: string
  }];
  matched_fields: {
    [key: string]: string
  };
}

export interface IMoveContactUploadItem {
  account_id: number;
  contact_account_id: number;
  contact_email: string;
  contact_first: string;
  contact_id: number;
  contact_last: number;
  destination_group: string;
  error: string;
  group_to: number;
  moved_result?: string;
}

export const EXCLUDED_DOMAINS_FROM_MASS_INACTIVE = ['mail.com', 'inbox.com', 'myway.com', 'rr.com', 'yandex.mail', 'zoho.com', 'att.net', 'gmail.com', 'yahoo.com', 'facebook.com', 'enbake.com', 'google.com', 'click2sell.com', 'mac.com', 'me.com', 'hotmail.com', 'iCloud.com', 'twitter.com', 'aol.com', 'outlook.com', 'mail.com', 'zoho.com', 'sbcglobal.net', 'bellsouth.net', 'earthlink.net', 'comcast.net', 'verizon.net', 'cox.net', 'charter.net', 'cdeducation.org'];

export interface IMovedContactItem {
  contact_id: number;
  message: string;
}

export interface IMoveContactResult {
  failed: number;
  moved: number;
}
